import { render, staticRenderFns } from "./MappingInfo.vue?vue&type=template&id=1a114424&scoped=true&"
import script from "./MappingInfo.vue?vue&type=script&lang=ts&"
export * from "./MappingInfo.vue?vue&type=script&lang=ts&"
import style0 from "./MappingInfo.vue?vue&type=style&index=0&id=1a114424&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a114424",
  null
  
)

export default component.exports